"use client";

import { useTranslations } from "next-intl";
import { useState } from "react";
import { sendJson } from "@/components/send-json/send-json";
import { useNotify } from "@/components/toaster/app-toaster";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

/** The lists a subscriber chooses from, with a save button; reached from the link in every email. */
export function PreferencesForm({ token, lists, chosen }: { token: string; lists: { id: string; name: string }[]; chosen: string[] }) {
  const t = useTranslations("publicBlog.newsletter.preferences");
  const notify = useNotify();
  const [ids, setIds] = useState(new Set(chosen));
  const flip = (id: string) => setIds((now) => { const next = new Set(now); if (!next.delete(id)) next.add(id); return next; });
  async function save() {
    const result = await sendJson("PUT", "/api/newsletter/manage", { action: "lists", token, listIds: [...ids] });
    if (result.ok) notify.success(t("saved")); else notify.error(t("error"));
  }
  return (
    <div className="flex max-w-xl flex-col gap-4">
      {lists.map((l) => <div key={l.id} className="flex items-center gap-2"><Checkbox id={`list-${l.id}`} checked={ids.has(l.id)} onCheckedChange={() => flip(l.id)} /><Label htmlFor={`list-${l.id}`}>{l.name}</Label></div>)}
      <div className="flex justify-end"><Button type="button" onClick={save}>{t("save")}</Button></div>
    </div>
  );
}
